// extracted by mini-css-extract-plugin
export default {"title":"RecentActivityContainer_title"};